export const UserCategories = [
  { key: "Seller", text: "Seller" },
  { key: "Manager", text: "Manager" },
  { key: "Back-office Operations", text: "Back-office Operations" },
  { key: "CENOPS", text: "CENOPS" }
  // { key: "GTFS", text: "GTFS" },
  // { key: "WWCD", text: "WWCD" },
];

export const WORLD_WIDE = 'Worldwide';